function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, useEffect } from 'react';
import useMergedRef from '../useMergedRef';

var useForm = function useForm() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      initialRef = _ref.initialRef,
      _ref$initialErrors = _ref.initialErrors,
      initialErrors = _ref$initialErrors === void 0 ? {} : _ref$initialErrors,
      _ref$initialMessages = _ref.initialMessages,
      initialMessages = _ref$initialMessages === void 0 ? {} : _ref$initialMessages,
      _ref$defaultMessages = _ref.defaultMessages,
      defaultMessages = _ref$defaultMessages === void 0 ? {} : _ref$defaultMessages;

  var formRef = useMergedRef(initialRef);

  var _useState = useState(initialErrors),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var _useState3 = useState(initialMessages),
      _useState4 = _slicedToArray(_useState3, 2),
      messages = _useState4[0],
      setMessages = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      submitted = _useState6[0],
      setSubmitted = _useState6[1]; // Update if errors or messages are updated from the outside


  useEffect(function () {
    setErrors(initialErrors);
  }, [initialErrors]);
  useEffect(function () {
    setMessages(initialMessages);
  }, [initialMessages]);
  /**
   * Validate elements using HTML5 form validation.
   *
   * If a check fails we first check for any custom messages associated with the
   * input name, for the failed property. If there are no custom messages we
   * fall back to the browser defaults.
   */

  var getErrors = function getErrors(elements, isSubmit) {
    return elements.reduce(function (newErrors, element) {
      var validity = element.validity,
          name = element.name,
          validationMessage = element.validationMessage;
      var customMessages = messages[name] || {};
      var failedProp; // Check ValidityState for any failed props. Note that as the props are
      // read-only and non-enumerable we cannot use Object.keys or Object.entries,
      // see https://developer.mozilla.org/en-US/docs/Web/API/ValidityState
      // eslint-disable-next-line no-restricted-syntax

      for (var key in validity) {
        if (validity[key] && key !== 'valid') {
          failedProp = key;
        }
      } // Get custom message or browser default


      var errorMsg = failedProp && (failedProp in customMessages || failedProp in defaultMessages) ? defaultMessages[failedProp] || customMessages[failedProp] : validationMessage; // If the form has been, is being submitted, or the check is for a custom error
      // set the error message, otherwise clear errors for the input

      if ((isSubmit || submitted || failedProp === 'customError') && errorMsg.length) {
        newErrors[name] = errorMsg;
      } else {
        delete newErrors[name];
      }

      return newErrors;
    }, _objectSpread({}, errors));
  };
  /**
   * Validate a single input.
   */


  var validateInput = function validateInput(evt, callback) {
    setErrors(getErrors([evt.target]));

    if (callback) {
      callback(evt);
    }
  };
  /**
   * Dispatch a custom submitted event.
   */


  var dispatchSubmittedEvent = function dispatchSubmittedEvent(detail) {
    var evt = new CustomEvent('submitted', {
      detail: detail
    });
    formRef.current.dispatchEvent(evt);
  };
  /**
   * Handle form submission.
   */


  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(evt, callback) {
      var target, elements, invalidElements, newErrors, isValid;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              target = evt.target;
              elements = target.elements;
              invalidElements = _toConsumableArray(elements).filter(function (el) {
                return !el.checkValidity();
              });
              newErrors = getErrors(invalidElements, true);
              isValid = target.checkValidity();
              setSubmitted(true);
              setErrors(newErrors); // Scroll to the first invalid input

              if (invalidElements.length) {
                invalidElements[0].scrollIntoView({
                  behavior: 'smooth'
                });
              } // Prevent submission if the form is invalid


              if (isValid) {
                _context.next = 12;
                break;
              }

              evt.preventDefault();
              dispatchSubmittedEvent(false);
              return _context.abrupt("return");

            case 12:
              if (callback) {
                _context.next = 15;
                break;
              }

              dispatchSubmittedEvent(true);
              return _context.abrupt("return");

            case 15:
              _context.prev = 15;
              _context.next = 18;
              return callback(evt);

            case 18:
              _context.next = 24;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](15);
              dispatchSubmittedEvent(false);
              throw _context.t0;

            case 24:
              dispatchSubmittedEvent(true);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[15, 20]]);
    }));

    return function handleSubmit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return {
    formRef: formRef,
    errors: errors,
    validateInput: validateInput,
    handleSubmit: handleSubmit
  };
};

export default useForm;